import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import StatusIndicator from "@cloudscape-design/components/status-indicator";
import { useQuery } from "@tanstack/react-query";
import { api, errorMessage } from "../../api/client";
import type { MessageResponse } from "../../api/types";
import { navigate, useQueryParam } from "../../router/useRoute";
import { PublicShell } from "./PublicShell";

export function VerifyEmailPage() {
  const verificationToken = useQueryParam("token");

  const { data, error, isPending } = useQuery({
    queryKey: ["verify-email", verificationToken],
    retry: false,
    queryFn: async () => {
      if (!verificationToken) throw new Error("Liên kết xác minh không hợp lệ hoặc đã hết hạn.");
      return api<MessageResponse>("/auth/verify-email", { method: "POST", body: { token: verificationToken } });
    },
  });

  return (
    <PublicShell title="Xác minh email">
      <SpaceBetween size="l">
        {isPending && <StatusIndicator type="loading">Đang kiểm tra liên kết kích hoạt</StatusIndicator>}
        {error && (
          <StatusIndicator type="error">{errorMessage(error)}</StatusIndicator>
        )}
        {data && <StatusIndicator type="success">{data.message}</StatusIndicator>}
        {!isPending && (
          <Box>
            <SpaceBetween size="xs" direction="horizontal">
              {error && (
                <Button
                  href="/resend-verification"
                  onFollow={(event) => {
                    event.preventDefault();
                    navigate("/resend-verification");
                  }}
                >
                  Gửi lại email xác minh
                </Button>
              )}
              <Button
                variant="primary"
                href="/login"
                onFollow={(event) => {
                  event.preventDefault();
                  navigate("/login");
                }}
              >
                Đăng nhập
              </Button>
            </SpaceBetween>
          </Box>
        )}
      </SpaceBetween>
    </PublicShell>
  );
}
